const Properties = {
    //urlTest: `http://localhost:4000/`,
    //urlBase: `http://localhost:4000/`, 
    urlBase: `https://app-maquetas.herokuapp.com/`,
    urlTest: `https://app-maquetas-test.herokuapp.com/`
}

export default Properties